// fill your code
// Reducer

import { createStore, combineReducers } from 'redux';

const initialState = {
    orderList: [],
    ListOfProduct: [
        { id: 1, productName: "Lenovo Laptop", price: "60000", quantity: 0 },
        { id: 2, productName: "Apple Laptop", price: "50000", quantity: 7},
        { id: 3, productName: "Asus Laptop", price: "40000", quantity: 3},
        { id: 4, productName: "HP NotePad", price: "80000", quantity: 10},
        { id: 5, productName: "MicroPhone", price: "55000", quantity: 6},
        { id: 6, productName: "LG Laptop", price: "63000", quantity: 8},
        { id: 7, productName: "Gaming Headset", price: "3000", quantity: 8 }
    ]
}


const reducer = (state = initialState, action) =>{

    if(action.type === 'REDUCE_QUANTITY'){

        Object.keys(state.ListOfProduct).map(i => {
            if(action.item.name === state.ListOfProduct[i].productName){
                state.ListOfProduct[i].quantity -= 1
            } 
        })


        
        return {
            ...state,
            ListOfProduct: [...state.ListOfProduct]
        }
    }

    if(action.type === 'ADD_TO_CART'){

        Object.keys(state.orderList).map(i => {
            if(state.orderList[i].name === action.item.name){
                state.orderList[i].quantity = state.orderList[i].quantity+1;
                action.item.quantity = state.orderList[i].quantity;
            }
        })


        return {
            ...state,
            orderList: [...state.orderList, action.item]
        }
    }


    if(action.type === 'REMOVE_FROM_CART'){
        const orders = state.orderList.filter( (ele, ind) => ind === state.orderList.findIndex( elem => elem.name === ele.name && elem.id === ele.id) && ele.name !== action.item.name)
        // const filtered = orders.filter( (ele, ind) => ele.name !== action.item.name)
        
        return {
            ...state,
            orderList: [...orders]
        }
    }

    return state;
}


// export const store = createStore(reducer);

export default combineReducers({reducer}) ;